import 'abortcontroller-polyfill';
import 'scroll-behavior-polyfill';
import 'polyfill-object.fromentries';
import 'array-flat-polyfill';

if (!window.queueMicrotask) {
  window.queueMicrotask = (callback) => {
    Promise.resolve()
      .then(callback)
      .catch((error) => {
        setTimeout(() => {
          throw error;
        }, 0);
      });
  };
}
